// extracted by mini-css-extract-plugin
module.exports = {"container":"socials_container__PO2Xt","icons":"socials_icons__uK6NL","social":"socials_social__iTRTt","circled":"socials_circled__n7CL4"};